import classNames from 'classnames';
import { useState } from 'react';

import { ArrowRight } from '@/icons/index';

import SectionTitle from '../SectionTitle/SectionTitle';
import Button from '../Button/Button';
import BusinessContactForm from '../BusinessContactForm/BusinessContactForm';

import styles from './Bundles.module.scss';

const Mounthly = ({ data, className }) => {
  const [activeModal, setActiveModal] = useState(false);

  const openModal = () => {
    setActiveModal(true);
  };

  const closeModal = () => {
    setActiveModal(false);
  };

  const renderMountlyTable = (item, index) => {
    return (
      <div
        className={styles['mounthly-table__row']}
        key={index}
        itemScope
        itemType='https://schema.org/FinancialProduct'
      >
        <div className={styles['mounthly-table__item']}>
          {item?.left_heading && (
            <span className={styles['mounthly-table__title']}>
              {item.left_heading}
            </span>
          )}
          <div className={styles['mounthly-table__currency']}>
            {item.left_text}
          </div>
        </div>
        <div className={styles['mounthly-table__item']}>
          {item?.right_heading && (
            <span className={styles['mounthly-table__title']}>
              {item.right_heading}
            </span>
          )}
          <div className={styles['mounthly-table__currency']}>
            {item.right_text}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className={classNames(styles.mounthly, className)}
      itemScope
      itemType='https://schema.org/FinancialProduct'
    >
      <div className={styles.mounthly__inner}>
        {data?.right_card_title && (
          <SectionTitle
            titleModify={classNames(styles.mounthly__title, 'title--large')}
          >
            {data?.right_card_title}
          </SectionTitle>
        )}
        {data?.right_card_sections && (
          <div className={styles['mounthly-table']}>
            {data?.right_card_sections?.map(renderMountlyTable)}
          </div>
        )}

        {data?.right_card_action_type === 'pop-up' ? (
          <Button
            className={styles.mounthly__button}
            onClick={() => openModal()}
            Component={'button'}
          >
            {data?.right_card_button_text}
            <ArrowRight width={20} />
          </Button>
        ) : (
          <Button
            className={styles.mounthly__button}
            Component={'router'}
            href={data?.right_card_page_slug}
          >
            {data?.right_card_button_text}
            <ArrowRight width={20} />
          </Button>
        )}
      </div>
      <BusinessContactForm
        activeModal={activeModal}
        clearTariff={closeModal}
        hasEmployeesCount={true}
      />
    </div>
  );
};

export default Mounthly;
